import styled, { css } from 'styled-components'

export const Map = styled.div`
  position: relative;
  width: 100%;
  height: 50vh;

  ${props =>
    props.sticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 900;
    `}
`
